import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { components } from 'react-select';
import { Input } from 'react-select/animated';
import { useTheme } from 'styled-components';
import Icons from '../../Elements/Icons';
import { Loader } from '../../Elements/Loader';
import { LoaderWrapper, MenuPortalWrapper, OptionDescription, OptionTitle, CheckWrapper } from './styled';
// CustomInput adds `name` to the `react-select`s main input to support focus operations by name (for final-form-focus)
const CustomInput = (props) => {
    if (!Input) {
        return null;
    }
    const { selectProps } = props;
    const { dataTestId, name, readOnly } = selectProps;
    return _jsx(Input, { ...props, "data-testid": dataTestId, name: name, readOnly: readOnly ?? false, autoComplete: 'off' });
};
export const CustomClearIcon = (props) => {
    const theme = useTheme();
    return (_jsx(components.ClearIndicator, { ...props, children: _jsx(Icons.Clear, { filled: true, color: theme.colors.grey70_1, size: 20 }) }));
};
export const CustomLoadingIndicator = () => {
    const theme = useTheme();
    return (_jsx(LoaderWrapper, { children: _jsx(Loader, { size: '14px', fill: theme.colors.grey100_1, background: 'transparent' }) }));
};
export const CustomLoadingMessage = (props) => {
    const theme = useTheme();
    return (_jsx(components.LoadingMessage, { ...props, children: _jsx(Loader, { size: '14px', fill: theme.colors.grey100_1 }) }));
};
export const CustomDropdownIcon = (props) => (_jsx(components.DropdownIndicator, { ...props, children: _jsx(Icons.Chevron, { align: 'bottom', size: 20 }) }));
export const CustomOption = ({ children, isSelected, ...props }) => (_jsxs(components.Option, { isSelected: isSelected, ...props, children: [_jsxs(OptionTitle, { "data-testid": 'option-label', children: [children, isSelected && (_jsx(CheckWrapper, { children: _jsx(Icons.Checkmark, { size: 20 }) }))] }), props?.data?.description ? _jsx(OptionDescription, { children: props?.data?.description }) : null] }));
export const CustomMultiValueRemove = (props) => {
    const theme = useTheme();
    return (_jsx(components.MultiValueRemove, { ...props, children: _jsx(Icons.Clear, { size: 16, color: theme.colors.grey100_1 }) }));
};
export const CustomMenuPortal = ({ children, ...props }) => (_jsx(components.MenuPortal, { ...props, children: _jsx(MenuPortalWrapper, { children: children }) }));
export const commonProps = {
    classNamePrefix: 'select',
    hideSelectedOptions: false,
    menuPortalTarget: document.querySelector('body'),
    menuPlacement: 'auto',
    components: {
        Input: CustomInput,
        ClearIndicator: CustomClearIcon,
        DropdownIndicator: CustomDropdownIcon,
        Option: CustomOption,
        LoadingIndicator: CustomLoadingIndicator,
        LoadingMessage: CustomLoadingMessage,
        MultiValueRemove: CustomMultiValueRemove,
        MenuPortal: CustomMenuPortal,
    },
};
export const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '36px',
    }),
    // portal need higher z-index than modal to be on top
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};
